export default "__VITE_ASSET__BNmq1V25__"